var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSingleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10766 18.2416C6.72183 18.6036 6.11712 18.5827 5.75701 18.1948C5.3969 17.8069 5.41776 17.199 5.80359 16.837L13.348 9.75837C13.7151 9.41388 14.2849 9.41388 14.652 9.75837L22.1964 16.837C22.5822 17.199 22.6031 17.8069 22.243 18.1948C21.8829 18.5827 21.2782 18.6036 20.8923 18.2416L14 11.7748L7.10766 18.2416Z",
    fill: "#005FC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSingleUp);
export default __webpack_public_path__ + "static/media/arrow-single-up.bdb3e4e9e58cb00f6f8929a3af0fcad1.svg";
export { ForwardRef as ReactComponent };